import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FaUserPlus, FaChevronDown, FaChevronUp, FaUsers } from 'react-icons/fa';
import ContactTable from './contact/ContactTable';
import { setCustomerContacts } from 'redux/crm/contactSlice';
import ContactForm from 'components/app/crm/contact/ContactForm';

const CustomerDetailContact = ({ customer, allow_create }) => {
  const [showForm, setShowForm] = useState(false);
  const { customerContacts: contacts } = useSelector((state) => state.crm_contact);
  const dispatch = useDispatch();

  useEffect(() => {
    if (customer) dispatch(setCustomerContacts(customer.contacts));
  }, [customer, dispatch]);

  return (
    <div className="tw-bg-white tw-rounded-lg tw-border tw-border-slate-200 tw-shadow-sm tw-mb-4">
      {/* Header */}
      <div className="tw-flex tw-items-center tw-justify-between tw-px-5 tw-py-3 tw-border-b tw-border-slate-100">
        <div className="tw-flex tw-items-center tw-gap-2">
          <FaUsers size={15} className="tw-text-blue-500" />
          <h5 className="tw-mb-0 tw-text-base tw-font-semibold tw-text-slate-700">
            Contacts
            {contacts?.length > 0 && (
              <span className="tw-ml-2 tw-inline-flex tw-items-center tw-justify-center tw-w-5 tw-h-5 tw-rounded-xl tw-bg-blue-100 tw-text-blue-700 tw-text-xs tw-font-bold">
                {contacts.length}
              </span>
            )}
          </h5>
        </div>

        {allow_create && (
          <button
            type="button"
            onClick={() => setShowForm((v) => !v)}
            className="tw-inline-flex tw-items-center tw-gap-1.5 tw-px-3 tw-py-1.5 tw-text-xs tw-font-medium tw-rounded-md tw-bg-blue-600 tw-text-white hover:tw-bg-blue-700 tw-border-0 tw-cursor-pointer tw-transition-colors"
          >
            <FaUserPlus size={12} />
            Add contact
            {showForm ? <FaChevronUp size={10} /> : <FaChevronDown size={10} />}
          </button>
        )}
      </div>

      {/* Collapsible form */}
      {showForm && (
        <div className="tw-px-5 tw-py-4 tw-border-b tw-border-dashed tw-border-slate-200 tw-bg-slate-50">
          <ContactForm
            customer={customer}
            handleCancel={() => setShowForm(false)}
          />
        </div>
      )}

      {/* Table */}
      <div className="tw-p-0">
        <ContactTable customer={customer} contacts={contacts || []} />
      </div>
    </div>
  );
};

CustomerDetailContact.propTypes = {
  customer:      PropTypes.object.isRequired,
  allow_create:  PropTypes.bool.isRequired,
};

export default CustomerDetailContact;
